export default [
  /* Login */
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/auth/Login')
  },

  /* Register */
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/pages/auth/Register'),
    meta: { guest: true }
  },

  /* Recovery */
  {
    path: '/recovery',
    name: 'Recovery',
    component: () => import('@/pages/auth/Recovery'),
    meta: { guest: true }
  },

  /* Profile */
  {
    path: '/profile',
    name: 'Profile',
    meta: {
      descricao: 'Profile'
    },
    component: () => import('@/pages/auth/profile/Profile')
  }
]
